import styles from './DeviceConfigHeader.module.css';
import { ButtonIcon, Search } from '@oolio-group/design-ui-react';
import { FC } from 'react';

interface Props {
  title: string;
  onBack?: () => void;
  searchTerm?: string;
  onSearchChange?: (value: string) => void;
  showSearch?: boolean;
  searchLabel?: string;
}
export const DeviceConfigHeader: FC<Props> = ({
  title,
  onBack,
  showSearch = false,
  onSearchChange,
  searchLabel,
  searchTerm,
}) => {
  return (
    <>
      <div className={styles.header}>
        <ButtonIcon
          buttonStyle="cancel"
          countStyle="focus"
          icon="arrow-left"
          onClick={onBack}
          size={44}
          disabled={!onBack}
        />
        <div className={styles.titleContainer}>
          <h2 className={styles.sectionTitle}>{title}</h2>
        </div>
      </div>

      {showSearch && (
        <div className={styles.searchContainer}>
          <Search
            id="search-sb"
            onChange={onSearchChange}
            placeholder={searchLabel}
            value={searchTerm}
          />
        </div>
      )}
    </>
  );
};
